import { render, staticRenderFns } from "./CecAboutForm.vue?vue&type=template&id=2e52fa34&scoped=true"
import script from "./CecAboutForm.vue?vue&type=script&lang=js"
export * from "./CecAboutForm.vue?vue&type=script&lang=js"
import style0 from "./CecAboutForm.vue?vue&type=style&index=0&id=2e52fa34&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e52fa34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e52fa34')) {
      api.createRecord('2e52fa34', component.options)
    } else {
      api.reload('2e52fa34', component.options)
    }
    module.hot.accept("./CecAboutForm.vue?vue&type=template&id=2e52fa34&scoped=true", function () {
      api.rerender('2e52fa34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/about/CecAboutForm.vue"
export default component.exports